import { render, staticRenderFns } from "./rcc-row.vue?vue&type=template&id=8ecb96e8&scoped=true&"
import script from "./rcc-row.vue?vue&type=script&lang=js&"
export * from "./rcc-row.vue?vue&type=script&lang=js&"
import style0 from "./rcc-row.vue?vue&type=style&index=0&id=8ecb96e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecb96e8",
  null
  
)

export default component.exports